import { Pagination } from "@core/domain/models/pagination";
import { EntityApiKeysRepository } from "@entity-api-keys/data/repositories/entity-api-keys.repository";
import { EntityApiKeys } from "@entity-api-keys/domain/models/entity-api-key.model";
import { inject, injectable } from "inversify";

export interface SearchEntityApiKeysParams {
    search?: string;
    entityId?: number;
    createdAfter?: string;
    createdBefore?: string;
    isActive?: boolean;
    scopes?: string[];
}

@injectable()
export class SearchEntityApiKeysUseCase {
    constructor(
        @inject(EntityApiKeysRepository)
        private readonly repository: EntityApiKeysRepository,
    ) {}

    async execute(
        pagination: Pagination,
        params?: SearchEntityApiKeysParams,
    ): Promise<EntityApiKeys> {
        const result = await this.repository.searchAllBy(
            pagination,
            params?.search,
            params?.entityId,
            params?.createdAfter,
            params?.createdBefore,
            params?.isActive,
            params?.scopes,
        );

        return result.fold(
            () => new EntityApiKeys([], 0),
            (keys) => keys,
        );
    }
}
